import { useQuery } from '@tanstack/react-query';
import API from '../../../../utils/api';

/**
 * Hook que obtiene los métodos de pago disponibles para el usuario autenticado.
 * Usa React Query con la clave `/user-payment-methods` y devuelve el array
 * de métodos expuesto por la API (API.getUserPaymentMethods).
 *
 * @returns UseQueryResult
 *
 * @example Estructura de cada elemento en `data`:
 * [
 *   {
 *     type: "card",
 *     gateway: "kushki",
 *     label: "Crédito/Débito (K)",
 *     icon: "visa-mastercard.png",
 *     bonus: false
 *   },
 *   {
 *     type: "spei",
 *     gateway: "muwe",
 *     label: "Transferencia",
 *     icon: "spei.png",
 *     bonus: { conditions: "...", image: "ccards/spei-bonus.png" }
 *   }
 * ]
 */
export const useGetUserPaymentMethods = () => {
  return useQuery(['/user-payment-methods'], async () => {
    return (await API.getUserPaymentMethods())?.data?.methods;
  });
};
